import { supabase } from './supabase';
import type { Json } from './database.types';

export interface LogAuditParams {
  action: string;
  entity_type?: string | null;
  entity_id?: string | null;
  diff?: Json | null;
  organization_id?: string | null;
}

/**
 * Best-effort audit log write from the client. Never throws — failures are
 * logged via console.warn so the calling flow can proceed.
 *
 * The `audit_insert_self` RLS policy in migration 0002 enforces:
 *   - user_id = auth.uid() (we don't pass it, server fills via DEFAULT)
 *   - organization_id is NULL or equals current_organization_id()
 * Pre-bootstrap auth events (signed_up, email_verified) intentionally pass
 * `organization_id: null` since the user has no org yet.
 */
export async function logAudit(p: LogAuditParams): Promise<void> {
  try {
    const { data: userData } = await supabase.auth.getUser();
    const userId = userData.user?.id ?? null;
    if (!userId) {
      console.warn('[audit] skipped (no auth.uid):', p.action);
      return;
    }
    const { error } = await supabase.from('audit_log').insert({
      user_id: userId,
      organization_id: p.organization_id ?? null,
      action: p.action,
      entity_type: p.entity_type ?? null,
      entity_id: p.entity_id ?? null,
      diff: p.diff ?? null,
    });
    if (error) {
      console.warn('[audit] failed:', p.action, error.message);
    }
  } catch (err) {
    console.warn('[audit] threw:', p.action, err);
  }
}
